// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gMkzI","label":"styles_label__Ed6f4"};